import { RotationCargoBM } from 'src/types/BusinessModel/Stowage/Rotation/RotationCargoBM';
import { RotationCargoOperationBM } from 'src/types/BusinessModel/Stowage/Rotation/RotationCargoOperationBM';
import { RotationPortCallBM } from 'src/types/BusinessModel/Stowage/Rotation/RotationPortCallBM';
import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';

export const createRotationCargo = (cargoBM: RotationCargoBM, cargoOperationBM: RotationCargoOperationBM): RotationCargo => {
    return {
        cargoGuid: crypto.randomUUID(),
        imosCargoId: cargoBM.cargoId,
        productId: cargoBM.productId,
        colorId: null,
        cargoNumber: cargoBM.cargoNumber,
        voyageNumber: cargoBM.voyageNumber,
        chartererName: cargoBM.chartererName,
        product: null,
        productChanges: null,
        temperature: null,
        optionType: cargoBM.optionType,
        optionMinusPercentage: cargoBM.optionMinusPercentage,
        optionPlusPercentage: cargoBM.optionPlusPercentage,
        cargoStatus: cargoOperationBM.cargoStatus,
        dataSource: null,
        comment: cargoBM.comment,
        loadingPortNames: [],
        unloadingPortNames: [],
    };
};
export const createRotationCargoList = (rotationPortCalls: RotationPortCallBM[]) =>
    rotationPortCalls
        .flatMap((pc) => pc.berthCalls?.flatMap((bc) => bc.cargoOperations?.map((co) => ({ cargo: co.cargo, operation: co }))))
        .filter((item, index, self) => self.findIndex((i) => i.cargo.cargoId === item.cargo.cargoId) === index)
        .map((item) => createRotationCargo(item.cargo, item.operation)) || [];
